import { render, staticRenderFns } from "./BrandHealthByGroup.vue?vue&type=template&id=33c8b10e&scoped=true&"
import script from "./BrandHealthByGroup.vue?vue&type=script&lang=js&"
export * from "./BrandHealthByGroup.vue?vue&type=script&lang=js&"
import style0 from "./BrandHealthByGroup.vue?vue&type=style&index=0&id=33c8b10e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c8b10e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib'
installComponents(component, {VRow})
